import { useEffect, useState } from "react";
import { fetchUserProfile } from "../services/user.service";

export default function useUserProfile() {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		let cancelled = false;
		(async () => {
			try {
				const res = await fetchUserProfile();
				if (!cancelled) setData(res);
			} catch (e) {
				if (!cancelled) setError(e?.response?.data?.message || e.message || "Failed to load profile");
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();
		return () => { cancelled = true; };
	}, []);

	return { data, loading, error };
}


